module.exports = __webpack_public_path__ + "static/media/undraw_empty.1745ba6d.svg";